import React, { useState } from 'react';
import { Container, Navbar, Nav, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function NavBar(props) {
	const [expand, updateExpanded] = useState(false);
	const [navColour, updateNavbar] = useState(false);

	function scrollHandler() {
		if (window.scrollY >= 20) {
			updateNavbar(true);
		} else {
			updateNavbar(false);
		}
	}

	function changeLanguage() {
		if (props.language === 'english') {
			props.setLanguage('polish');
			localStorage.setItem('language', 'polish');
		} else {
			props.setLanguage('english');
			localStorage.setItem('language', 'english');
		}
	}

	let english = {
		"about": "About",
		"projects": "Projects",
		"resume": "Resume",
		"language": "EN"
	};

	let polish = {
		"about": "O mnie",
		"projects": "Projekty",
		"resume": "Kariera",
		"language": "PL"
	};

	let language = '';
	if (props.language === 'english') {
		language = english;
	} else {
		language = polish;
	}

	window.addEventListener('scroll', scrollHandler);

	return (
		<Navbar expanded={expand} fixed='top' expand='md' className={navColour ? 'sticky' : 'navbar'}>
			<Container>
				<Navbar.Brand href='/'>
					<h3 className='pt-1'>RB</h3>
				</Navbar.Brand>
				<Navbar.Toggle aria-controls='responsive-navbar-nav'
					onClick={() => {
						updateExpanded(expand ? false : 'expanded');
					}}>
					<span></span>
					<span></span>
					<span></span>
				</Navbar.Toggle>
				<Navbar.Collapse id='responsive-navbar-nav'>
					<Nav className='ml-auto' defaultActiveKey='#home'>
						<Nav.Item>
							<Nav.Link as={Link} to='/' onClick={() => updateExpanded(false)}>
								<i className='fas fa-home'></i> Home
              </Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link as={Link} to='/about' onClick={() => updateExpanded(false)}>
								<i className='far fa-user'></i> {language.about}
							</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link as={Link} to='/projects' onClick={() => updateExpanded(false)}>
								<i className='fab fa-codepen'></i> {language.projects}
							</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link as={Link} to='/resume' onClick={() => updateExpanded(false)}>
								<i className='far fa-file-alt'></i> {language.resume}
							</Nav.Link>
						</Nav.Item>
						<Nav.Item className='fork-btn'>
							<Button className='fork-btn-inner' onClick={changeLanguage}>
								<i className='fas fa-globe'></i> {language.language}
							</Button>
						</Nav.Item>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}

export default NavBar;
